var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.bindIshow)?_c('pcbind',{on:{"closeBindDialog":_vm.closeBindDialog}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }